import * as React from "react";
const Upload = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2906 5.18848L10.0979 0.995813L5.90527 5.18848"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M10.0977 12.2539L10.0977 2.11182"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M19 10.0039C19 14.9764 15.625 19.0039 10 19.0039C4.375 19.0039 1 14.9764 1 10.0039"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Upload;
